import Tabs from "@/components/common/Tabs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Transaction from "./Transaction";
import { useUserStore } from "@/modules/auth/store/user";

const Transactions = () => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState("all");

  const { deposits } = useUserStore();

  const tabs = [
    { value: "all", label: t("mydeposits-page.filters.all") },
    { value: "active", label: t("mydeposits-page.filters.active") },
    { value: "completed", label: t("mydeposits-page.filters.completed") },
  ];

  const filteredDeposits = deposits.filter((tx) => {
    const status = tx.deposit.status;

    if (status === "Cancelled") return false;

    if (activeTab === "active") {
      return status === "Active" || status === "Created";
    }

    if (activeTab === "completed") {
      return status === "Closed";
    }

    return true;
  });

  return (
    <div className="w-full flex flex-col gap-3">
      <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

      {filteredDeposits.map((tx, index) => (
        <Transaction key={index} {...tx} />
      ))}
    </div>
  );
};

export default Transactions;
